import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config/constants';
import { useSelector } from 'react-redux';
import './processStatus.scss';
import CurrentProcess from './components/CurrentProcess';
import OperationRate from './components/OperationRate';
import Downtime from './components/Downtime';
import DetailedDataPenel from './components/DetailedDataPenel';
import OperationRateDetailModal from './components/OperationRateDetailModal';

function ProcessStatus(props) {
    const [sumDsArr, setSumDsArr] = useState([]);
    const [selSumDsId, setSelSumDsId] = useState(-1);
    const [psData, setPsData] = useState(null);
    const [sdsData, setSdsData] = useState(null);
    const [byDateData, setByDateData] = useState([]);
    const [dtData, setDtData] = useState({
        totalDowntime: 0,
        plannedDowntime: 0,
        unplannedDowntime: 0,
    })
    const [isOpen, setIsOpen] = useState(false);
    const { privilege, userRank } = useSelector((state) => state.session);
    async function getStructs() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getStructs`);
        const sumDs = response.data.sumDs;
        setSumDsArr([...sumDs]);
        setSelSumDsId(sumDs.length > 0 ? sumDs[0].sumDsId : -1);
    };

    async function getProcessStatus() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getProcessStatus`, { sumDsId: selSumDsId });
        console.log(`total: ${response.data.psData.totalProduce}`)
        setPsData(response.data.psData ? { ...response.data.psData, totalProduce: response.data.psData.totalProduce } : null);
        setSdsData({ ...response.data.sdsData });
        setByDateData([...response.data.byDate]);
        setDtData({ ...response.data.dtData });
    };

    const onClickSumDs = (e, id) => {
        e.preventDefault();
        setSelSumDsId(id);
        setPsData(null);
        setSdsData(null);
        setByDateData([]);
        setDtData({
            totalDowntime: 0,
            plannedDowntime: 0,
            unplannedDowntime: 0,
        });
    };

    useEffect(() => {
        getStructs();
    }, [])
    useEffect(() => {
        if (sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        }
    }, [sumDsArr]);
    useEffect(() => {
        if (selSumDsId >= 0) {
            getProcessStatus();

            const intervalId = setInterval(() => {
                getProcessStatus();
            }, 5000); // 5초 간격

            return () => clearInterval(intervalId);
        }
    }, [selSumDsId]);
    return (
        <React.Fragment>

            <div className='psPage'>
                <div className='psMenuArea'>
                    <ul className='psMenuUl'>
                        {
                            sumDsArr.map((el, sumDsIdx) => (
                                <li key={`sumDs_mon_${sumDsIdx}`} className='psMenuLi'>
                                    <button className='psMenuBtn' onClick={e => onClickSumDs(e, el.sumDsId)} disabled={selSumDsId === el.sumDsId}>{el.name}</button>
                                </li>
                            ))
                        }
                    </ul>
                </div>
                <div className='psContentArea'>
                    {
                        !!psData ?
                            <div>
                                <p className='path'>
                                    공정 상태
                                    <span className='below'>{'>'}</span>
                                    {selSumDsId >= 0 ? sumDsArr.filter(el => el.sumDsId === selSumDsId)[0].name : null}
                                </p>
                                <div className='statusArea'>
                                    {/* 공정 현황 */}
                                    <CurrentProcess psData={psData} />
                                    {/* 가동율 */}
                                    <OperationRate psData={psData} byDate={byDateData} openDetail={e => {
                                        e.preventDefault(); setIsOpen(true);
                                    }} />
                                    {/* 비가동 현황 */}
                                    <Downtime dtData={dtData} />
                                </div>
                                <div className='dDataPannelArea'>
                                    {/* 세부 데이터 패널 */}
                                    {
                                        sdsData !== null ?
                                            sdsData.grpName.map((grpNameStr, index) => {
                                                if (sdsData.valView[index].filter(el => el === true).length > 0) {
                                                    return (
                                                        <DetailedDataPenel
                                                            key={`ddPen_${index}`}
                                                            grpIdx={index}
                                                            sumDsId={selSumDsId}
                                                            grpName={grpNameStr}
                                                            dataClass={sdsData.dataClass[index]}
                                                            indexName={sdsData.indexName[index]}
                                                            valView={sdsData.valView[index]}
                                                            stdVal={JSON.parse(psData.Model.stdVal)[index]}
                                                        />
                                                    )
                                                }
                                            }) : null
                                    }

                                </div>
                            </div>
                            : null
                    }
                </div>
            </div>
            <OperationRateDetailModal
                isOpen={isOpen}
                onRequestClose={e => {
                    e.preventDefault();
                    setIsOpen(false);
                }}
                sdsData={sdsData}
            />
        </React.Fragment>
    );
}

export default ProcessStatus;